"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkQueryType = void 0;
var BenchmarkQueryType;
(function (BenchmarkQueryType) {
    BenchmarkQueryType["Max"] = "max";
    BenchmarkQueryType["Min"] = "min";
})(BenchmarkQueryType = exports.BenchmarkQueryType || (exports.BenchmarkQueryType = {}));
